import React, { useState, useEffect } from 'react';
import { useStyles } from '../../theme';
import { snakeCase } from 'lodash';
import { useQuery } from '@apollo/client';
import { GetGigEventLabels } from '../../queries/getGigEvents';
import { getGigEventDisplayName } from '../../Helper';
import { useIsFeatureFlagEnabled } from '../../contexts/feature-flag-context';
import { SelectListContent } from '../SelectListContents';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { Typography } from '@material-ui/core';
import { FILTER_OUTLINE_ICON } from '../../constants';

const styles = (theme) => ({
  buttonWrapper: {
    justifyContent: 'end',
    display: 'flex',
    margin: "16px 32px 8px"
  },
  applyButton: {
    backgroundColor: '#00BBBB !important',
    width: 97,
    color: 'white',
    boxShadow: 'none !important',
  }
});

export const GigLastEventFilter = ({ appliedFilters, onClickApply, title }) => {
  const [open, setOpen] = useState(false);
  const { loading, error, data: eventOptions } = useQuery(GetGigEventLabels);
  const priorityFiltersFlag = useIsFeatureFlagEnabled("vip-fe-priority-filters");
  
  const classes = useStyles(styles);

  const formatOptions = (options) => {
    return options.map((option) => ({
      label: getGigEventDisplayName(option.label),
      value: snakeCase(option.label)
    }));
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const allOptions = formatOptions(eventOptions?.events || []);

  const getValueFromAppliedOptions = (applied) => {
    return allOptions.filter((option) => applied.includes(option.value));
  };

  const options = loading ? [] : error ? [] : allOptions;

  const value = appliedFilters?.lastEvent || [];

  const [currentValue, setCurrentValue] = useState(
    getValueFromAppliedOptions(appliedFilters?.eventType || [])
  );

  const handleSelectValueChange = (event) => {
    const {
      target: { value },
    } = event;
    setCurrentValue(value);
  };

  const handleOnSelectValueChange = (selectValues) => {
    setCurrentValue(value);
    onClickApply({ eventType: selectValues.map((val) => val.value) });
  };

  const handleClickApply = (event) => {
    onClickApply({ eventType: typeof currentValue === 'string' ? currentValue.split(',') : currentValue });
    handleClose();
  };

  useEffect(() => {
    setCurrentValue(appliedFilters?.eventType || []);
  }, [open, appliedFilters]);

  const MenuProps = {
    PaperProps: {
      style: {
        width: 304,
      },
    },
  };

  return (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: 5,
        marginRight: 20,
        position: 'relative' // Ensure positioning context
    }}>
      {priorityFiltersFlag ? 
      (<FormControl>
        <Select
          sx={{ minWidth: 200, maxHeight: 38, backgroundColor: 'white' }}
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          open={open}
          onOpen={options.length > 0 && handleOpen}
          onClose={handleClose}
          multiple
          displayEmpty={true}
          value={currentValue}
          onChange={handleSelectValueChange}
          renderValue={() => <Typography variant="body2" style={{verticalAlign: "text-bottom", color: "black"}}>
              <img
                src={FILTER_OUTLINE_ICON}
                height="16px"
                alt="Filter Icon"
                style={{ marginRight: 5 }}
              /> Last Event ({appliedFilters?.eventType?.length || 0}) 
            </Typography>}
          MenuProps={MenuProps}
        >
          {options.map((option) => (
            <MenuItem sx={{padding: "2px 0", '&.Mui-selected': {backgroundColor: 'white'}}} key={option.value} value={option.value}>
              <Checkbox checked={currentValue.includes(option.value)} sx={{
                padding: '0 9px',
                margin: '4px',
                color: '#A8A8A8',
                '&.Mui-checked': {
                  color: '#00BBBB',
                }
              }}/>
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
          <div className={classes.buttonWrapper}>
            <Button className={classes.applyButton} variant="contained" onClick={handleClickApply}>
              <Typography variant="body3">Apply</Typography>
            </Button>
          </div>
        </Select>
      </FormControl>) :
        (
        <SelectListContent
          title={title}
          value={currentValue}
          options={options}
          onChange={handleOnSelectValueChange}
          isMulti={true}
          maxWidth={700}
          minWidth={250}
        />)}
    </div>
  );
};
